/*
 * POESIE Plausible event wiring.
 *
 * The script tag in theme.liquid loads the self-hosted Plausible script
 * (outbound-links + pageview-props + revenue + tagged-events) and defines the
 * window.plausible queue stub. This file fires the custom events that can't be
 * expressed declaratively: the age gate choice, newsletter success, and the
 * Dawn AJAX add-to-cart. "Begin checkout" is tagged directly on the button in
 * poesie-product.liquid (it's a real navigation, so tagged-events handles the
 * beacon-before-unload for us).
 *
 * Goal names must match the Plausible dashboard goals character-for-character.
 */
(() => {
  const track = (name, options) => {
    if (typeof window.plausible === 'function') window.plausible(name, options);
  };

  // Age gate — the first choice every first-time visitor makes. The decline
  // rate is a real signal; accept lets us measure how many clear the gate.
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('[data-age-accept]')) {
      track('Age gate accept');
    } else if (target.closest('[data-age-decline]')) {
      track('Age gate decline');
    }
  });

  // Newsletter — the success message only renders after Shopify confirms the
  // subscribe (full page reload), so its presence is the reliable signal.
  const checkNewsletterSuccess = () => {
    if (document.querySelector('.newsletter-form__message--success')) {
      track('Newsletter signup');
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkNewsletterSuccess);
  } else {
    checkNewsletterSuccess();
  }

  // Add to cart — product-form.js publishes cartUpdate only on a successful
  // add, with the cart-add response as cartData. Guarded in case the globals
  // load late or the page has no AJAX cart.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || event.source !== 'product-form') return;
      const item = event.cartData || {};
      track('Add to cart', {
        props: { product: item.product_title || document.title }
      });
    });
  }
})();
